window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs, an) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.LanguageSelect = function() {
	this.initialize(img.LanguageSelectAssets_LanguageSelect);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1080);


(lib.LaptopBackArrow = function() {
	this.initialize(img.LanguageSelectAssets_LaptopBackArrow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,18,21);


(lib.LaptopBackArrowWhite = function() {
	this.initialize(img.LanguageSelectAssets_LaptopBackArrowWhite);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,18,21);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.SelectConfirmButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.instance = new lib.LaptopBackArrowWhite();
	this.instance.setTransform(9,-10,1,1,0,0,180);

	this.instance_1 = new lib.LaptopBackArrow();
	this.instance_1.setTransform(9,-10,1,1,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance}]},2).wait(1));

	// Layer_3
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#2C3C3C").s().p("Ah5E2Qi6AAAAiqIAAkXQAAiqC6AAIDzAAQC6AAAACqIAAEXQAACqi6AAg");
	this.shape.setTransform(0.025,-1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("rgba(255,255,255,0)").ss(0.1,1,1).p("Ah5k1IDzAAQC6AAAACqIAAEXQAACqi6AAIjzAAQi6AAAAiqIAAkXQAAiqC6AAg");
	this.shape_1.setTransform(0.025,-1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AiEE2QivAAAAigIAAkrQAAigCvAAIEJAAQCvAAAACgIAAErQAACgivAAg");
	this.shape_2.setTransform(0.025,-1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#C7C7C9").s().p("AiEE2QivAAAAigIAAkrQAAigCvAAIEJAAQCvAAAACgIAAErQAACgivAAg");
	this.shape_3.setTransform(0.025,-1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-31.7,-33,63.5,64);


(lib.DropdownItemContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.DropdownItem = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("English", "28px 'Work Sans SemiBold'", "#2C3C3C");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 266;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(9,2);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("English", "28px 'Work Sans SemiBold'", "#2C3C3C");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 266;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(9,2);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("English", "28px 'Work Sans SemiBold'", "#2C3C3C");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 266;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(9,2);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("English", "28px 'Work Sans SemiBold'", "#EEEAE5");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 266;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(9,2);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Layer_7
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#EEEAE5").s().p("A5JDrIAAnVMAyTAAAIAAHVg");
	this.shape.setTransform(153.996,24.9861,0.9565,1.0638);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("A5JDrIAAnVMAyTAAAIAAHVg");
	this.shape_1.setTransform(154.001,24.9861,0.9565,1.0638);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#C7C7C9").s().p("A2YDdIAAm5MAsxAAAIAAG5g");
	this.shape_2.setTransform(154.0098,25.0167,1.0748,1.1328);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,308,50);


(lib.DropdownButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Arrow
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#534741").ss(2,0,0,3).p("ABbgwIhbBaIhaha");
	this.shape.setTransform(303.45,35.1536);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#2C3C3C").ss(2,0,0,3).p("ABbgwIhbBaIhaha");
	this.shape_1.setTransform(303.45,35.1536);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f().s("#EEEAE5").ss(2,0,0,3).p("ABbgwIhbBaIhaha");
	this.shape_2.setTransform(303.45,35.1536);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},2).wait(1));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("English", "28px 'Work Sans SemiBold'", "#2C3C3C");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 266;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(21.1,11);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("English", "28px 'Work Sans SemiBold'", "#EEEAE5");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 266;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(21.1,11);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("English", "28px 'Work Sans SemiBold'", "#2C3C3C");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 266;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(21.1,11);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("English", "28px 'Work Sans SemiBold'", "#2C3C3C");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 266;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(21.1,11);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Layer_3
	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f().s("rgba(255,255,255,0)").ss(0.1,1,1).p("A1Kk1MAqVAAAQCgAAAACgIAAErQAACgigAAMgqVAAAQigAAAAigIAAkrQAAigCgAAg");
	this.shape_3.setTransform(165.7803,31,1.094,1);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("A1KE2QigAAAAigIAAkrQAAigCgAAMAqVAAAQCgAAAACgIAAErQAACgigAAg");
	this.shape_4.setTransform(165.7803,31,1.094,1);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#EEEAE5").s().p("A1KE2QigAAAAigIAAkrQAAigCgAAMAqVAAAQCgAAAACgIAAErQAACgigAAg");
	this.shape_5.setTransform(165.7803,31,1.094,1);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f().s("rgba(255,255,255,0)").ss(0.1,1,1).p("AkXjFIIvAAIAAGLIovAAg");
	this.shape_6.setTransform(408.7,57.3);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#C7C7C9").s().p("A1KE2QigAAAAigIAAkrQAAigCgAAMAqVAAAQCgAAAACgIAAErQAACgigAAg");
	this.shape_7.setTransform(165.7803,31,1.094,1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_4},{t:this.shape_3}]}).to({state:[{t:this.shape_6},{t:this.shape_5}]},1).to({state:[{t:this.shape_7},{t:this.shape_3}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1,-1,438.7,79.1);


(lib.LoadingBarBar2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FAF5F0").s().p("A7zBBIAAiBMA3nAAAIAACBg");
	this.shape.setTransform(178,6.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LoadingBarBar2, new cjs.Rectangle(0,0,356,13), null);


(lib.LoadingBarBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#E6CAAC").s().p("A7zBBIAAiBMA3nAAAIAACBg");
	this.shape.setTransform(178,6.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LoadingBarBar, new cjs.Rectangle(0,0,356,13), null);


(lib.LanguageDropdown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.dropDownButton = new lib.DropdownButton();
	this.dropDownButton.name = "dropDownButton";

	this.timeline.addTween(cjs.Tween.get(this.dropDownButton).wait(1));

	// Layer_2
	this.item = new lib.DropdownItem();
	this.item.name = "item";
	this.item.setTransform(10,62);

	this.timeline.addTween(cjs.Tween.get(this.item).wait(1));

	// Layer_1
	this.itemContainer = new lib.DropdownItemContainer();
	this.itemContainer.name = "itemContainer";
	this.itemContainer.setTransform(10,62);

	this.timeline.addTween(cjs.Tween.get(this.itemContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LanguageDropdown, new cjs.Rectangle(0,0,331.6,112), null);


(lib.LoadingBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// LoadingBarBar copy
	this.instance = new lib.LoadingBarBar2();
	this.instance.setTransform(721.25,10,1.7432,1,0,0,0,0.1,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// LoadingBarBar
	this.instance_1 = new lib.LoadingBarBar();
	this.instance_1.setTransform(3,10,3.7603,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LoadingBar, new cjs.Rectangle(3,10,1338.7,13), null);


(lib.LanguageSelectScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.languageDropdown = new lib.LanguageDropdown();
	this.languageDropdown.name = "languageDropdown";
	this.languageDropdown.setTransform(-202.15,20.3);

	this.timeline.addTween(cjs.Tween.get(this.languageDropdown).wait(1));

	// subtitleTextField
	this.selectTextField = new cjs.Text("Please select your language:", "40px 'Work Sans'", "#1E1E28");
	this.selectTextField.name = "selectTextField";
	this.selectTextField.textAlign = "center";
	this.selectTextField.lineHeight = 47;
	this.selectTextField.lineWidth = 1881;
	this.selectTextField.parent = this;
	this.selectTextField.setTransform(0,-63.05);
ranj.TextOffsetFixer.fix(this.selectTextField);

	this.subtitleTextField = new cjs.Text("A Digital Readiness and Response Simulation", "bold 56px 'Work Sans ExtraBold'", "#324242");
	this.subtitleTextField.name = "subtitleTextField";
	this.subtitleTextField.textAlign = "center";
	this.subtitleTextField.lineHeight = 81;
	this.subtitleTextField.lineWidth = 1881;
	this.subtitleTextField.parent = this;
	this.subtitleTextField.setTransform(0,-206.05);
ranj.TextOffsetFixer.fix(this.subtitleTextField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.subtitleTextField},{t:this.selectTextField}]}).wait(1));

	// LanguageSelectButton
	this.continueButton = new lib.SelectConfirmButton();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(171.4,53.3);

	this.timeline.addTween(cjs.Tween.get(this.continueButton).wait(1));

	// background
	this.loadingBar = new lib.LoadingBar();
	this.loadingBar.name = "loadingBar";
	this.loadingBar.setTransform(-518.3,-247.95,1,1,0,0,0,157.5,12.2);

	this.instance = new lib.LanguageSelect();
	this.instance.setTransform(-960,-540);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.loadingBar}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LanguageSelectScreenSkin, new cjs.Rectangle(-960,-540,1920,1080), null);


// stage content:
(lib.LanguageSelectAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(961,540,960,540);
// library properties:
lib.properties = {
	id: '2D758ABF18A3194E856740076AC96F36',
	width: 1920,
	height: 1080,
	fps: 60,
	color: "#000000",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/LanguageSelect/LanguageSelect.jpg", id:"LanguageSelectAssets_LanguageSelect", bundle:"LanguageSelectAssets"},
		{src:"assets/skins/images/LanguageSelect/LaptopBackArrow.png", id:"LanguageSelectAssets_LaptopBackArrow", bundle:"LanguageSelectAssets"},
		{src:"assets/skins/images/LanguageSelect/LaptopBackArrowWhite.png", id:"LanguageSelectAssets_LaptopBackArrowWhite", bundle:"LanguageSelectAssets"}
	],
	preloads: []
};



an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(lib.LanguageSelectAssets = {}, images, ss, createjs, AdobeAn = AdobeAn||{});
var AdobeAn;
module.exports = lib.LanguageSelectAssets;